module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold_1.d46e2f26.woff";